const nominowChartDefaults = require('./nominow-chart-defaults.js');

(function () {
	Vue.component('nominow-chart-columns', {
		mixins: [nominowChartDefaults.mixin],
		template: `<div :id="id"></div>`,
		props: {
			init: {
				type: Object,
				required: true
			},
			chartData: {
				type: Object,
				required: true
			},
			chartRequest: {
				type: Object,
				required: true
			}
		},
		data: function () {
			return {
				id: 'nnchartcolumn-' + new Date().getTime(),
				chart: null
			}
		},
		created: function () {
			Vue.nextTick(() => {
				this.setupChart();
			});
		},
		methods: {
			setupChart: function () {
				var colors = window.getChartColors(this.chartData.Values.length);
				const drilldown = this.chartData.Drilldown;

				let drillDownValues = this.getDrillDownValues(drilldown);

				var data = Array.prototype.map.call(this.chartData.Values, (el, i) => {
					let dimension = el.Dimension1;
					const dimension2 = el.Dimension2;
					if (dimension2) {
						dimension += ` ${dimension2}`
					}
					return {
						no: i + 1,
						y: el.Fact1 || el.Number,
						count: window.groupDigits(el.Number),
						name: dimension,
						color: colors[i],
						drilldown: drilldown ? dimension : null
					}
				});
				const maxAvg = this.getMaxAverage(data);

				const plotlines = this.getPlotLines(this.chartRequest.plotLines, maxAvg, -10);

				Highcharts.setOptions({ lang: { drillUpText: '◁ Back' } });

				var redrawEnabled = true;
				this.chart = Highcharts.chart(this.id, $.extend(true, {}, this.chartDefaults(), {
					chart: {
						type: 'column',
						events: {
							drilldown: function () {
								this.xAxis[0].title = 'testest';
								for (let i = 0; i < plotlines.length; i++) {
									this.yAxis[0].removePlotLine(plotlines[i].id);
								}
							},
							drillup: function () {
								this.xAxis[0].title = null;
								for (let i = 0; i < plotlines.length; i++) {
									this.yAxis[0].addPlotLine(plotlines[i]);
								}
							},
							redraw: function () {
								if (redrawEnabled) {
									redrawEnabled = false;
									var maxValue = !this.drillUpButton ? this.yAxis[0].dataMax * 1.1 : maxAvg.max;
									this.yAxis[0].setExtremes(0, maxValue);
									redrawEnabled = true;
								}
							}
						}
					},
					plotOptions: {
						column: {
							pointPadding: 0.2,
							borderWidth: 0
						}
					},
					xAxis: {
						type: 'category',
						lineColor: globalColors.primary.hue1,
						gridLineColor: globalColors.primary.hue1,
						lineWidth: 1,
						tickWidth: 0,
						labels: {
							style: {
								color: globalColors.primary.hue9
							}
						},
					},
					yAxis: {
						max: maxAvg.max,
						title: {
							text: this.chartData.Kpi[0].KPIName,
							style: {
								color: globalColors.primary.hue9
							}
						},
						labels: {
							style: {
								color: globalColors.primary.hue9
							}
						},
						tickColor: globalColors.primary.hue1,
						lineColor: globalColors.primary.hue1,
						gridLineColor: globalColors.primary.hue1,
						lineWidth: 1,
						tickWidth: 1,
						showFirstLabel: false,
						showLastLabel: false,
						plotLines: window.cloneObject(plotlines)
					},
					series: [
						{
							data: data,
							dataLabels: {}
						}
					],
					drilldown: drillDownValues,
				}));
				this.$emit('chartReady', this.chart);
			},
			getDrillDownValues: function (drilldown) {
				let drillDownValues = {};
				if (drilldown) {
					const drilldownobj = {};
					for (var i = 0; i < drilldown.length; i++) {
						var row = drilldown[i];
						if (!drilldownobj[row["Dimension1"]]) {
							drilldownobj[row["Dimension1"]] = {
								id: row["Dimension1"],
								data: []
							};
						}
						drilldownobj[row["Dimension1"]]["data"].push([row["Dimension2"], row['Fact1']]);
					}
					drillDownValues = {
						activeAxisLabelStyle: {
							color: globalColors.primary.hue9,
							fontWeight: 'normal'
						},
						series: []
					};
					for (var key in drilldownobj) {
						drillDownValues.series.push(drilldownobj[key]);
					}
				}
				return drillDownValues;
			}
		}
	})
})();

